
import './MapLegend.css'
// @ts-ignore
import mapLegendImage from '../../assets/img/controls/map_legend.png';

export const MapLegend = () => {
    
    return(
        <>
            <div className={'map-legend-content'} >
                <div className={'map-legend-image'}>
                    <img src={mapLegendImage} alt={'Map Legend Image'} />
                </div>
            </div>
        </>
    )
}
